// DifficultyBadge.js — small visual chip for "basic" / "intermediate" / "advanced".
// Renders nothing when level is undefined/null so we can drop it into existing
// cards without disturbing their layout until backend starts tagging content.
//
// Ryan-feedback scaffold for "difficulty-tiered quizzes". Once the backend
// supplies a difficulty tier on Topic / QuizQuestion, pass it through here.
import React from "react";
import { View, Text, StyleSheet } from "react-native";

const DIFFICULTY_VISUAL = {
  basic: { label: "Basic", bg: "#dcfce7", text: "#166534", darkBg: "rgba(34,197,94,0.18)", darkText: "#86efac" },
  intermediate: { label: "Intermediate", bg: "#fef3c7", text: "#92400e", darkBg: "rgba(245,158,11,0.18)", darkText: "#fbbf24" },
  advanced: { label: "Advanced", bg: "#fee2e2", text: "#991b1b", darkBg: "rgba(239,68,68,0.18)", darkText: "#fca5a5" },
};

function normalize(level) {
  if (!level) return null;
  const k = String(level).toLowerCase();
  if (k.startsWith("b") || k === "easy" || k === "1") return "basic";
  if (k.startsWith("i") || k === "medium" || k === "2") return "intermediate";
  if (k.startsWith("a") || k.startsWith("h") || k === "3") return "advanced";
  return null;
}

export default function DifficultyBadge({ level, isDarkMode = false, size = "sm", style }) {
  const key = normalize(level);
  if (!key) return null;
  const v = DIFFICULTY_VISUAL[key];
  const small = size === "sm";
  return (
    <View
      style={[
        styles.chip,
        {
          backgroundColor: isDarkMode ? v.darkBg : v.bg,
          paddingVertical: small ? 2 : 4,
          paddingHorizontal: small ? 8 : 10,
          borderRadius: small ? 8 : 10,
        },
        style,
      ]}
    >
      <Text
        style={{
          color: isDarkMode ? v.darkText : v.text,
          fontSize: small ? 10 : 12,
          fontWeight: "600",
          letterSpacing: 0.3,
        }}
      >
        {v.label.toUpperCase()}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  chip: {
    alignSelf: "flex-start",
    flexDirection: "row",
    alignItems: "center",
  },
});
